module.exports = __webpack_public_path__ + "img/logo-fullsize.8d5b48bc.png";